import type { Media } from '../../types/props.js'

export interface FaqItem {
  title: string
  desc: string
  img: Media
}

/** Faq 组件语义化样式名称 */
export type FaqSemanticName = 'root' | 'item' | 'itemHeader' | 'title' | 'icon' | 'content' | 'description'

export interface FaqProps {
  data: {
    productData: FaqItem[]
  }
  className?: string
  /** 默认展开的 item 索引，可以是单个数字或数字数组 */
  defaultOpenIndex?: number | number[]
  /** 语义化样式透传 */
  classNames?: Partial<Record<FaqSemanticName, string>>
}
